import { useOutlet } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import { LoadingPage } from "@/components/LoadingPage/LoadingPage";
import { MyEditorProvider } from "@/context/EditorProvider";
import { useTenantData } from "@/hooks/useTenantData";
import { getIsLivePreviewPage } from "@/utils/routes";

export const AuthLayout = () => {
    const outlet = useOutlet();
    const isLivePreviewPage = getIsLivePreviewPage();
    const { isLoading: isTenantLoading } = useTenantData();

    if (isTenantLoading) {
        return <LoadingPage />;
    }

    return (
        <ErrorBoundary>
            {isLivePreviewPage ? (
                <>{outlet}</>
            ) : (
                <MyEditorProvider>{outlet}</MyEditorProvider>
            )}
        </ErrorBoundary>
    );
};
